import React, { Component } from 'react';
// import firebase from 'firebase';
// import { bindActionCreators } from 'redux';
// import { connect } from 'react-redux';
// import * as actionCreators from './actions/actionCreators';

import NavBar from './components/NavBar';
// import LogIn from './components/LogIn';
import './Main.css';

// const firebaseConfig = {
//   apiKey: "AIzaSyBiVS2jJtUg8L5zq8kymLCa25_lcp-V9h8",
//   authDomain: "update-my-address-book.firebaseapp.com",
//   databaseURL: "https://update-my-address-book.firebaseio.com",
//   storageBucket: "update-my-address-book.appspot.com",
//   messagingSenderId: "400174057547"
// };

// firebase.initializeApp(firebaseConfig);

// function mapStateToProps(state) {
// 	return {
// 		addresses : state.addresses,
// 		user : state.user
// 	}
// }

// function mapDispatchToProps(dispatch) {
// 	return bindActionCreators(actionCreators, dispatch);
// }

// const theApp = connect(mapStateToProps, mapDispatchToProps);

class Main extends Component {
	// constructor() {
	// 	super();

	// 	// firebase.auth().onAuthStateChanged((user) => {
	// 	// 	// this.setState({user});
	// 	// 	this.props.authChanged(user);
	// 	// 	if (user) {
	// 	// 		// console.log('authenticated 🙂!');
	// 	// 		localStorage.authenticated = true;
	// 	// 	} else {
	// 	// 		// console.log('Not authenticated ☹!');
	// 	// 		localStorage.authenticated = false;
	// 	// 	}
	// 	// });
	// }

  render() {
  	// TODO: fix this dirty hack
  	// const isLoggedIn = this.props.user !== null || this.props.location.pathname.substr(0,5) === '/new/';

  	//if (isLoggedIn) {
	    return (
	      <div className="logged-in">
	        <NavBar {...this.props}/>
		      <div id="main-view" className="container">
						{ React.cloneElement(this.props.children, this.props) }
	       	</div>
	      </div>
	    )
		/* } else {
		    return (
		      <div className="logged-out">
		        <NavBar/>
		        <LogIn/>
		      </div>
		    )
		}*/
  }
}

export default Main;



// WEBPACK FOOTER //
// ./src/Main.js